import script from "./CollageTileDefaultLayoutGridOptionB.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollageTileDefaultLayoutGridOptionB.vue?vue&type=script&lang=ts&setup=true"

import "./CollageTileDefaultLayoutGridOptionB.vue?vue&type=style&index=0&id=11201cb2&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11201cb2"]])

export default __exports__